import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import './privacy.css';

const keywords = ['TERRA', 'TERRA FORESTA', 'TERRA COAT', '株式会社TERRA', 'TERRA株式会社', '光触媒'];

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>個人情報保護方針 | 株式会社TERRA</title>
      </Helmet>
      <div className="privacy">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          個人情報保護方針
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>個人情報保護方針</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <br />
          <br />
          <br />
          <p>
            株式会社TERRA（以下、「当社」といいます。）は、以下のとおり個人情報保護方針を定め、
            個人情報保護の仕組みを構築し、全従業員に個人情報保護の重要性を認識させるとともにその取組みを徹底させることにより、
            個人情報の保護を推進します。
          </p>
          <p className="text_title">第1条（個人情報）</p>
          <p>
            「個人情報」とは、個人情報の保護に関する法律（平成十五年法律第五十七号、以下「個人情報保護法」といいます。）
            にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、
            生年月日その他の記述等により特定の個人を識別できるもの又は個人識別符号が含まれるものを指します。
          </p>
          <p className="text_title">第2条（個人情報の取得と利用）</p>
          <p>
            当社は、以下の目的に必要な範囲で、ご本人の個⼈情報を取得し、
            取得した情報を利用させていただきます。以下の⽬的の範囲を超えて個⼈情報を利⽤する場合には、
            事前に適切な⽅法でご本人からの同意を得るものとします。
            <ol className="bracket">
              <li>当社サービスの提供のため</li>
              <li>当社サービスの内容を改良・改善し、又は新サービスを開発するため</li>
              <li>
                当社サービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスのご案内
                （電子メール、チラシ、その他のダイレクトメールの送付を含む）のため
              </li>
              <li> メンテナンス、重要なお知らせなど必要に応じたご連絡のため</li>
              <li> 当社サービスに関する利用者からのお問い合わせに回答するため（本人確認を行うことを含む）</li>
              <li> 当社サービスの利用状況を利用者にご報告するため</li>
              <li> 当社サービスに関するアンケート・取材等のご協力依頼や各種イベントへのご参加をお願いし、又はその結果などをご報告するため</li>
              <li> 当社サービスの利用履歴等を調査・分析し、その結果を当社サービスの改良・開発や広告の配信に利用するため</li>
              <li> 利用規約に違反した利用者や、不正・不当な目的で当社サービスを利用しようとする利用者の特定をし、ご利用をお断りするため</li>
            </ol>
          </p>

          <p className="text_title">第3条（個人情報の適切な取得）</p>
          <p>
            1. 当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
            <br />
            2. 当社は、次の場合を除き、あらかじめ本人の同意を得ないで、要配慮個人情報（個人情報保護法第2条第3項に定義されるものを意味します。）を取得しません。
            <ol className="bracket">
              <li>第4条各号のいずれかに該当する場合</li>
              <li>
                当該要配慮個人情報が、本人、国の機関、地方公共団体、
                個人情報保護法第76条第1項各号に掲げる者その他個人情報保護委員会規則で
                定める者により公開されている場合
              </li>
              <li>本人を目視し、又は撮影することにより、その外形上明らかな要配慮個人情報を取得する場合</li>
            </ol>
            3. 当社は、第三者から個人情報の提供を受けるに際しては、個人情報保護委員会規則で定めるところにより、次に掲げる事項の確認を行います。
            ただし、当該個人情報の提供が第4条各号のいずれかに該当する場合を除きます。
            <ol className="bracket">
              <li>
                当該第三者の氏名又は名称及び住所、並びに法人の場合はその代表者
                （法人でない団体で代表者又は管理人の定めのあるものの場合は、その代表者又は管理人）の氏名
              </li>
              <li>当該第三者による当該個人情報の取得の経緯</li>
            </ol>
          </p>

          <p className="text_title">第4条（本件液剤の継続的売買）</p>
          <p>
            個人情報の管理は、厳重に行うこととし、次に掲げる場合を除き、
            ご本人の同意がない限り、第三者に対しデータを開示・提供することはいたしません。
            <br />
            また、安全性を考慮し、個人情報への不正アクセス、個人情報の紛失、
            破壊、改ざん及び漏えい等のリスクに対する予防並びに是正に関する対策を講じます。
            <ol className="bracket">
              <li>
                当社サービスの内容を改善するために当社が業務を委託する業者に対して開示する場合
              </li>
              <li>人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難である場合</li>
              <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難である場合</li>
              <li>
                国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、
                本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがある場合
              </li>
              <li>業務を円滑に遂行するため、利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合</li>
              <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
              <li>
                個人情報を特定の者との間で共同して利用する場合であって、
                その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、
                利用する者の利用目的及び当該個人情報の管理について責任を有する者の氏名又は名称について、
                あらかじめ本人に通知し、又は本人が容易に知り得る状態に置いた場合
              </li>
              <li>その他法令で認められる場合</li>
            </ol>
          </p>

          <p className="text_title">第5条（第三者提供）</p>
          <p>
            1. 当社は、当社が取得した個人情報につき、東京営業所、山梨営業所、名古屋営業所、
            千葉営業所、秦野営業所、各営業センター、コールセンター、また必要に応じて、
            参加するイベント及び購入される商品の実施スタッフに対し、取得した個人情報を提供することがあります。
            <br />
            2. 当社は、前項に該当する場合を除くほか、あらかじめ本人の同意を得ないで、
            個人情報を第三者に提供しません。但し、次に掲げる場合は上記に定める第三者への提供には該当しません。
            <ol className="bracket">
              <li>利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託することに伴って個人情報を提供する場合</li>
              <li>合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
            </ol>
            3. 当社は、個人情報を第三者に提供したときは、個人情報保護法第25条に従い、記録の作成及び保存を行います。
            <br />
            4. 当社は、第三者から個人情報の提供を受ける場合には、個人情報保護法第26条に従い、必要な確認を行い、当該確認にかかる記録の作成及び保存を行うものとします。
          </p>

          <p className="text_title">第6条(個人情報の取扱いの委託)</p>
          <p>
            当社は、利用目的の達成に必要な範囲内において、個人情報の取扱いの全部又は一部を委託する場合がございます。
            この場合、当社は、委託先としての適格性を十分審査するとともに、契約にあたって守秘義務に関する事項等を定め、
            委託先に対する必要かつ適切な監督を行います。また、当社は、取得個人情報の全部又は一部を、
            個人情報保護法の定めに基づいて共同利用することがございます。
          </p>

          <p className="text_title">第7条（個人情報の開示）</p>
          <p>
            当社は、ご本人から個人情報の開示を求められたときは、ご本人に対し、遅滞なくこれを開示します。
            但し、開示することにより次のいずれかに該当する場合は、その全部又は一部を開示しないこともあり、
            開示しない決定をした場合には、その旨を遅滞なく通知します。
            <ol className="bracket">
              <li>ご本人又は第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
              <li>当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
              <li>その他法令に違反することとなる場合</li>
            </ol>
          </p>

          <p className="text_title">第8条（個人情報の訂正及び削除）</p>
          <p>
            1. 当社の保有する個人情報が誤った情報である場合には、ご本人の請求により、当社が定める手続きに従い個人情報の訂正又は削除を行います。
            <br />
            2. 当社は、ご本人から前項の請求を受けてその請求に応じる必要があると判断した場合には、
            遅滞なく、当該個人情報の訂正又は削除を行い、これをご本人に通知します。
          </p>

          <p className="text_title">第9条（個人情報の利用停止等）</p>
          <p>
            当社は、ご本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、
            又は不正の手段により取得されたものであるという理由により、その利用の停止又は消去（以下、「利用停止等」といいます。）
            を求められた場合には、遅滞なく必要な調査を行い、その結果に基づき、個人情報の利用停止等を行い、
            その旨ご本人に通知します。但し、個人情報の利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、
            ご本人の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じます。
          </p>

          <p className="text_title">第10条(プライバシーポリシーの変更手続)</p>
          <p>
            当社は本ポリシーの内容を適宜見直し、その改善に努めます。本ポリシーの内容は、
            法令その他本ポリシーに別段の定めのある事項を除いて、変更することができるものとします。
            変更後のプライバシーポリシーは、当社所定の方法により、利用者に通知し、
            又は当社ウェブサイトに掲載したときから効力を生じるものとします。
          </p>

          <p className="text_title">第11条（法令、規範の遵守）</p>
          <p>当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守します。</p>

          <p className="text_title">第12条（Cookie（クッキー）その他の技術の利用）</p>
          <p>
            当社サービスは、Cookie及びこれに類する技術を利用することがあります。これらの技術は、
            当社による当社サービスの利用状況等の把握に役立ち、サービス向上に資するものです。
            Cookieを無効化されたいユーザーは、ウェブブラウザの設定を変更することによりCookieを無効化することができます。
            但し、Cookieを無効化すると、当社サービスの一部の機能をご利用いただけなくなる場合があります。
          </p>

          <p className="text_title">第13条（苦情及び相談への対応）</p>
          <p>
            当社は、個人情報の取扱いに関するご本人からの苦情、相談を受け付け、適切かつ迅速に対応いたします。
            また、ご本人からの当該個人情報の開示、訂正、追加、削除、利用又は提供の拒否などのご要望に対しても、迅速かつ適切に対応いたします。
          </p>

          <p className="text_title">第14条（お問い合わせ窓口）</p>
          <p>
            当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。
            <br />
            株式会社TERRA
            <br />
            【住所】東京都港区元赤坂 1-7-18 メットライフ元赤坂イースト 7F
            <br />
            【電話番号】03-6812-9104
          </p>
          <p className="text-right">2021年2月 制定</p>
          <br />
          <br />
          <p className="text-center font-weight-bold phone_number" style={{ fontSize: '4rem', letterSpacing: '0.5rem', lineHeight: '1' }}>0120-406-520</p>
          <p className="text-center phone_time" style={{ fontSize: '1.5rem', letterSpacing: '0.2rem' }}>24時間365日対応</p>
        </div>
      </div>
    </TheLayout>
  );
};
export default Privacy;
